module.exports = __webpack_public_path__ + "media/images/homes/FinalHomeBanner-458d4774dba78fb985dcf20405a79814.png";